// removed by extract-text-webpack-plugin
module.exports = {"opted-out-info":"OptOutInfo__opted-out-info___2fboy","show-info":"OptOutInfo__show-info___3ChoL","hide-info":"OptOutInfo__hide-info___1qUX1"};